import React from 'react'
import * as PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Hero from '../components/hero'
import Timeline from '../components/timeline'
import i18n from '../components/i18n'

const propTypes = {
  data: PropTypes.object.isRequired,
}

class IndexPage extends React.Component {
  render() {
    const pages = this.props.data.pages.edges
    const homePages = this.props.data.homePages.edges
    const currentLanguage = 'sv'
    i18n.language = currentLanguage

    if (i18n.language != currentLanguage)
      i18n.changeLanguage(currentLanguage)

    return (
      <div>
        <Hero pages={homePages} language={currentLanguage} />
        <Timeline pages={pages} language={currentLanguage} />
      </div>
    );
  }
}

IndexPage.propTypes = propTypes

export default IndexPage

export const pageQuery = graphql`
  query IndexSvQuery {
    pages: allContentfulPage(
      filter: { node_locale: { eq: "sv" } },
      sort: { fields: [title] }
    ) {
      edges {
        node {
          id
          node_locale
          title
  	      slug
          subtitle
          image {
            sizes(maxWidth: 720) {
              base64
              aspectRatio
              src
              srcSet
              sizes
            }
          }
          body {
            childMarkdownRemark {
              html
            }
          }
          featuredContent
        }
      }
    }
    homePages: allContentfulPage(
      filter: {
        featuredContent: { eq: true },
        node_locale: { eq: "sv" }
      }) {
      edges {
        node {
          id
          node_locale
          title
          slug
          subtitle
          image {
            sizes(maxWidth: 720) {
              base64
              aspectRatio
              src
              srcSet
              sizes
            }
          }
          body {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
    heroImage: imageSharp(id: { regex: "/hero/" }) {
      sizes(maxWidth: 1440) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/sv.js